// extracted by mini-css-extract-plugin
module.exports = {"changePlanButton":"ChangePlanButton_changePlanButton__3O4ec"};